import { selectAnatomy as parts } from "@chakra-ui/anatomy"
import type {
  PartsStyleFunction,
  PartsStyleObject,
  SystemStyleFunction,
} from "@chakra-ui/theme-tools"
import { mergeWith } from "@chakra-ui/utils"
import { Input } from "./input"

const baseStyleField: SystemStyleFunction = (props) => {
  return {
    _focus: {
      borderColor: 'transparent',
    }
  }
}

const baseStyle: PartsStyleFunction<typeof parts> = (props) => ({
  field: baseStyleField(props),
})

const iconSpacing = { paddingInlineEnd: "2rem" }

const sizes: Record<string, PartsStyleObject<typeof parts>> = mergeWith(
  {},
  Input.sizes,
  {
    lg: {
      field: iconSpacing,
    },
    md: {
      field: iconSpacing,
    },
    sm: {
      field: iconSpacing,
    },
    xs: {
      field: iconSpacing,
      icon: { insetEnd: "0.25rem" },
    },
  },
)

export const Select = {
  parts: parts.keys,
  baseStyle,
  sizes,
  variants: Input.variants,
  defaultProps: Input.defaultProps,
}